const oneYearFromNow = () => {
    // get the current date
    const date = new Date();

    // add one year
    date.setFullYear(date.getFullYear() + 1);

    // return as timestamp
    return date.getTime();
}

const isInPast = (isoString) => {
    // create a Date object with the provided string
    const date = new Date(isoString);

    // get the current date
    const now = new Date();

    // return true if the provided date is in the past, false otherwise
    return date.getTime() < now.getTime();
}

const convertToUserTimeZoneAndFormat = (dateString) => {
    // create a Date object with the provided string
    const date = new Date(dateString);

    // Use built-in methods to display date and time in user's local timezone and format
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const createEvent = (parent, { brand, title, startDateTime, endDateTime, description, location, image }) => {
    const eventDiv = document.getElementById("event_prototype").cloneNode(true);
    eventDiv.id = "";
    eventDiv.classList.remove("hidden");

    const titleDiv = eventDiv.querySelector(".event__title--title");
    titleDiv.innerText = title;

    const brandDiv = eventDiv.querySelector(".event__title--author");
    brandDiv.innerText = "Posted by " + brand;

    const startDateDiv = eventDiv.querySelector(".event__date--start");
    startDateDiv.innerText = convertToUserTimeZoneAndFormat(startDateTime) + " - ";

    const endDateDiv = eventDiv.querySelector(".event__date--end");
    if (endDateTime === startDateTime) {
        endDateDiv.innerText = "";
    } else {
        endDateDiv.innerText = convertToUserTimeZoneAndFormat(endDateTime);
    }

    const locationDiv = eventDiv.querySelector(".event__title--location");
    locationDiv.innerText = location;

    const descriptionDiv = eventDiv.querySelector(".event__content");
    descriptionDiv.innerText = description;

    const imageImg = eventDiv.querySelector(".event__image");
    imageImg.src = image;

    parent.appendChild(eventDiv);
}

const loadEvents = async () => {
    const res = await fetch(`https://app.shop3d.io/api/platform_cms/platform_store_events/only-games/filter?startDateTo=${oneYearFromNow()}`);
    const data = await res.json();
    const upcomingEvents = data.filter(event => !isInPast(event.endDateTime));
    const pastEvents = data.filter(event => isInPast(event.endDateTime));

    if (upcomingEvents.length > 0) {
        const parent = document.getElementById("upcoming-events");
        parent.innerHTML = "";
        upcomingEvents.sort((a, b) => {
            return new Date(a.startDateTime) - new Date(b.startDateTime);
        });
        upcomingEvents.forEach(event => {
            createEvent(parent, event);
        })
    } else {
        document.getElementById("upcoming-events").innerText = "Nothing here yet. Check back soon!"
    }

    if (pastEvents.length > 0) {
        const parent = document.getElementById("past-events");
        parent.innerHTML = "";
        pastEvents.sort((a, b) => {
            return new Date(b.startDateTime) - new Date(a.startDateTime);
        });
        pastEvents.forEach(event => {
            createEvent(parent, event);
        })
    } else {
        document.getElementById("past-events").innerText = "Nothing here."
    }
}

loadEvents().catch(console.error)
